<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import { VMoney } from "v-money";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  directives: { money: VMoney },
  data() {
    return {
      loading: false,

      sales: false,
      cellphone: "",
      email: "",

      shipping_status: false,
      shipping_order_min: "",

      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2
      },
    };
  },
  methods: {
    getSettings() {
      api
        .get("settings")
        .then((response) => {
          if (response.data.status == "success") {
            this.sales = (response.data.partner.sales == 'active') ? true : false;
            this.cellphone = response.data.partner.cellphone;
            this.email = response.data.partner.email;
            this.shipping_status = (response.data.partner.shipping_status == 'active') ? true : false;
            this.shipping_order_min = response.data.partner.shipping_order_min;
          }
        })
    },
    saveSettings() {
      this.loading = true;

      api
        .post("settings", {
          sales: this.sales ? "active" : "inactive",
          cellphone: this.cellphone,
          email: this.email,
          shipping_status: this.shipping_status ? "active" : "inactive",
          shipping_order_min: this.shipping_order_min,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("As configurações foram salvas com sucesso.");
          } else {
            this.$toast.error(response.data.message);
          }

          this.loading = false;
        })
        .catch(() => {
          this.$toast.error("Não foi possível salvar as configurações.");
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getSettings();
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Configurações</h3>
        <p></p>
      </div>
    </div>

    <fieldset>
      <div class="row justify-content-center">
        <div class="col-md-6 py-4">
          <b-form-group label="Status" label-for="cellphone" class="mb-4">
            <b-form-checkbox v-model="sales" switch size="lg"> Habilitar as vendas dos produtos</b-form-checkbox>
          </b-form-group>
          <b-form-group label="Celular" label-for="cellphone">
            <b-form-input v-model="cellphone" type="text" autocomplete="off" v-mask="'(##) #####-####'"></b-form-input>
          </b-form-group>
          <b-form-group label="E-mail" label-for="email">
            <b-form-input v-model="email" type="text" autocomplete="off"></b-form-input>
          </b-form-group>
          <b-form-group label="Frete Grátis" label-for="shipping_status" class="mb-4">
            <b-form-checkbox v-model="shipping_status" switch size="lg"> Habilitar o frete grátis</b-form-checkbox>
          </b-form-group>
          <b-form-group label="Valor Mínimo do Pedido" label-for="shipping_order_min">
            <b-form-input v-model="shipping_order_min" v-money="money" type="text" autocomplete="off"></b-form-input>
          </b-form-group>
          <div>
            <button class="btn btn-default btn-lg" v-on:click="saveSettings()" :disabled="loading">
              Salvar
              <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </Layout>
</template>